module.exports = __webpack_public_path__ + "static/media/wave.039bdd0a.svg";